import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { useStore } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  CustomInput,
} from "reactstrap";
import {
  AvForm,
  AvGroup,
  AvField,
  AvCheckboxGroup,
} from "availity-reactstrap-validation";

import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";

const dataService = require("../../services/dataServices.js");

const EditQuote = () => {
  let { quote_id } = useParams();
  const navigate = useHistory();
  const [text, setText] = useState("");
  const [source, setSource] = useState("");
  const [active, setActive] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const store = useStore();
  const currentUser =
    store.getState().authentication.user ??
    (localStorage.getItem("user") !== null
      ? JSON.parse(localStorage.getItem("user"))
      : null);

  async function constructObject() {
    var obj = {
      quote_id: quote_id,
      text: text,
      source: source,
      active_flag: active === true ? 1 : 0,
    };

    return obj;
  }

  async function save() {
    setIsLoading(true);
    setIsDisabled(true);

    var obj = await constructObject();
    await dataService.updateQuote(obj);

    showToastr();
  }

  function performCancel() {
    navigate.push("/system-content/quotes");
  }

  useEffect(() => {
    async function loadData() {
      // load the role
      var data = await dataService.quote(quote_id);

      setText(data.text);
      setSource(data.source);
      setActive(data.active_flag === 1);

      setIsLoading(false);
      setIsDisabled(!hasWritePermission());
    }

    function hasWritePermission() {
      var result = false;

      if (currentUser.permissions) {
        const matchIndex = currentUser.permissions.findIndex(function (row) {
          return row === "quotes_write";
        });
        if (matchIndex > -1) {
          result = true;
        }
      } else {
        result = true;
      }

      return result;
    }

    loadData();
  }, [quote_id, currentUser]);

  function showToastr() {
    const options = {
      timeOut: 3000,
      showCloseButton: true,
      progressBar: false,
      position: "top-center",
      onHideComplete: () => {
        setIsLoading(false);
        setIsDisabled(false);
      },
    };
    const toastrInstance = toastr.success;
    toastrInstance(
      "Edit Quote",
      "Your changes have been saved successfully.",
      options
    );
  }

  return (
    <Container fluid>
      <Header>
        <HeaderTitle>Edit Quote</HeaderTitle>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/dashboard">Dashboard</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/system-content/quotes">Quotes</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Edit Quote</BreadcrumbItem>
        </Breadcrumb>
      </Header>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <AvForm onValidSubmit={save}>
                <Row>
                  <Col sm={6}>
                    <AvGroup>
                      <Label for="text">Text</Label>
                      <AvField
                        bsSize="lg"
                        type="textarea"
                        name="text"
                        id="text"
                        placeholder="Enter text"
                        value={text}
                        disabled={isLoading}
                        rows="4"
                        onChange={(e) => setText(e.target.value)}
                        validate={{
                          required: {
                            value: true,
                            errorMessage: "Please enter the text.",
                          },
                        }}
                      />
                    </AvGroup>
                  </Col>
                  <Col sm={6}>
                    <AvGroup>
                      <Label for="source">Source</Label>
                      <AvField
                        bsSize="lg"
                        type="text"
                        name="source"
                        id="source"
                        placeholder="Enter source"
                        value={source}
                        disabled={isLoading}
                        onChange={(e) => setSource(e.target.value)}
                        validate={{
                          required: {
                            value: true,
                            errorMessage: "Please enter a source.",
                          },
                        }}
                      />
                    </AvGroup>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={4}>
                    <Label for="active">Active?</Label>
                    <AvCheckboxGroup name={"active"}>
                      <CustomInput
                        type="checkbox"
                        id={"active"}
                        label="Active"
                        checked={active}
                        disabled={isLoading}
                        onChange={(e) => setActive(e.target.checked)}
                      />
                    </AvCheckboxGroup>
                  </Col>
                </Row>
                <div className="mt-3">
                  <Button
                    color="light"
                    size="lg"
                    className="mr-2"
                    onClick={performCancel}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" size="lg" disabled={isDisabled}>
                    {isLoading && (
                      <Spinner size="sm" className="mr-2 align-middle" />
                    )}
                    Save
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EditQuote;
